import React, { useMemo } from "react";
import { Card, Row, Col, Badge, Button } from "react-bootstrap";
import { FaCalendarAlt, FaClock } from "react-icons/fa";
import { MdEditSquare } from "react-icons/md";
import { useTranslation } from "react-i18next";
import { formatNumber } from "../../utils/helpers";

const EXTRA_SERVICE_PRICE = 25;

export default function StepFive({
  pickupForms,
  deliveryForms,
  shipmentsByStop,
  totalWeight,
  subTotal,
  price,
  selectedOption,
  invoiceEmail,
  invoiceCompanyName,
  invoiceSalutation,
  invoiceFirstName,
  invoiceLastName,
  invoiceStreet,
  invoicePostalCity,
  invoicePhone,
  invoiceAddressExtra,
  invoiceVatId,
  extraServices,
  message,
  previousData,
  setCurrentStep,
}) {
  const { t } = useTranslation();

  console.log('totalWeight', totalWeight);

  const formatDate = (dateStr) => {
    if (!dateStr || typeof dateStr !== "string") return dateStr;
    const parts = dateStr.split("-");
    if (parts.length === 3) return `${parts[2]}.${parts[1]}.${parts[0]}`;
    return dateStr;
  };

  const allShipmentsFlat = useMemo(
    () => (Array.isArray(shipmentsByStop) ? shipmentsByStop.flat() : []),
    [shipmentsByStop],
  );

  const renderAddressCard = (title, forms, type, step) => (
    <div className="mb-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5 className="mb-0 text-dark fw-bold">{title}</h5>
        <Button
          variant="warning"
          size="sm"
          className="p-1 px-2"
          style={{
            borderRadius: "8px",
            borderColor: "#ff6b00",
            color: "#ff6b00",
            backgroundColor: "#ffffff",
          }}
          onClick={() => setCurrentStep(step)}
        >
          <MdEditSquare size={18} />
        </Button>
      </div>
      <Card className="border-0" style={{ borderRadius: "16px", backgroundColor: "#ffffff" }}>
        <Card.Body className="p-3">
          {forms.map((form, index) => (
            <div key={index} className="address-card p-3 mb-2 bg-light rounded-3">
              <strong
                className="d-block mb-2"
                style={{ fontSize: "1.1rem", color: "#ff6b00" }}
              >
                {type === "pickup" ? t("pickup_form") : t("delivery_form")}{" "}
                {index + 1}
              </strong>
              <div className="small mt-2 text-dark fw-medium">
                {form.companyName && <div className="fw-semibold">{form.companyName}</div>}
                <div>
                  {form.firstName} {form.lastName}
                </div>
                <div>{form.street}</div>
                {form.addressExtra && <div>{form.addressExtra}</div>}
                <div>{form.postalCity}</div>
                <div>{form.phone}</div>
                {form[
                  type === "pickup" ? "pickupReference" : "deliveryReference"
                ] && (
                  <div className="text-muted">
                    Referenz Nr.{" "}
                    {
                      form[
                        type === "pickup"
                          ? "pickupReference"
                          : "deliveryReference"
                      ]
                    }
                  </div>
                )}
                {form[type === "pickup" ? "pickupDate" : "deliveryDate"] && (
                  <div className="mt-2 text-muted">
                    <FaCalendarAlt className="me-1 text-orange" style={{ color: "#ff6b00" }} />{" "}
                    {formatDate(
                      form[type === "pickup" ? "pickupDate" : "deliveryDate"],
                    )}
                    <br />
                    <FaClock className="me-1 text-orange" style={{ color: "#ff6b00" }} /> {form.timeFrom} -{" "}
                    {form.timeTo}
                  </div>
                )}
              </div>
            </div>
          ))}
        </Card.Body>
      </Card>
    </div>
  );

  return (
    <div className="step-five">
      <h4 className="mb-4">{t("booking_overview")}</h4>

      <div className="stepfive-container">
        <Row className="gy-2 review-card">
          <Col lg={6}>
            {renderAddressCard(t("pickup_addresses"), pickupForms, "pickup", 2)}
          </Col>

          <Col lg={6}>
            {renderAddressCard(
              t("delivery_addresses"),
              deliveryForms,
              "delivery",
              3,
            )}
          </Col>

          <Col lg={6}>
            <div className="mb-4">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h5 className="mb-0">{t("invoice_address")}</h5>
                <Button
                  variant="warning"
                  size="sm"
                  className="text-white p-2"
                  style={{
                    borderRadius: "8px",
                    backgroundColor: "#ff7b00",
                    border: "none",
                  }}
                  onClick={() => setCurrentStep(4)}
                >
                  <MdEditSquare size={18} />
                </Button>
              </div>
              <Card className=" border-0">
                <Card.Body className="p-4" style={{ borderRadius: "12px" }}>
                  <div className="invoice-info">
                    <div className="small text-muted">
                      <div className="mb-2">
                        <Badge bg="secondary">{selectedOption}</Badge>
                      </div>
                      {invoiceEmail && (
                        <div>
                          {t("email_label")}: {invoiceEmail}
                        </div>
                      )}
                      {invoiceCompanyName && (
                        <div>
                          {t("company_label")}: {invoiceCompanyName}
                        </div>
                      )}
                      {(invoiceFirstName || invoiceLastName) && (
                        <div>
                          {t("name_label")}: {invoiceSalutation}{" "}
                          {invoiceFirstName} {invoiceLastName}
                        </div>
                      )}
                      {invoiceStreet && (
                        <div>
                          {t("address_label")}: {invoiceStreet}
                        </div>
                      )}
                      {invoiceAddressExtra && (
                        <div>
                          {t("address_extra_label")}: {invoiceAddressExtra}
                        </div>
                      )}
                      {invoicePostalCity && (
                        <div>
                          {t("city_label")}: {invoicePostalCity}
                        </div>
                      )}
                      {invoicePhone && (
                        <div>
                          {t("phone_label")}: {invoicePhone}
                        </div>
                      )}
                      {invoiceVatId && (
                        <div>
                          <strong>{t("vat_id_label")}:</strong> {invoiceVatId}
                        </div>
                      )}
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </div>
          </Col>

          <Col lg={6}>
            <div className="mb-4">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h5 className="mb-0">{t("selected_vehicle")}</h5>
              </div>
              <Card className="border-0 h-100">
                <Card.Body className="p-4" style={{ borderRadius: "12px" }}>
                  <div className="vehicle-info">
                    <div className="d-flex align-items-center mb-2">
                      <Badge bg="info" className="me-2 px-3 py-2">
                        {previousData.selectedVehicle.name}
                      </Badge>
                    </div>
                    <div className="text-muted">
                      {previousData.selectedVehicle.size ||
                        previousData.selectedVehicle.vehicle_size}
                      {previousData.selectedVehicle.id === 4 &&
                        previousData.selectedVehicle.crane && (
                          <div className="mt-1">
                            {previousData.selectedVehicle.crane === "yes"
                              ? t("with_crane")
                              : t("without_crane")}
                          </div>
                        )}
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </div>

            {previousData?.summary && (
              <div className="mb-4">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h5 className="mb-0">{t("route_info")}</h5>
                </div>
                <Card className="border-0">
                  <Card.Body className="p-4" style={{ borderRadius: "12px" }}>
                    <div className="route-info text-muted">
                      <div className="mb-2">
                        <strong>{t("distance")}:</strong>{" "}
                        {previousData.summary.distance} Km
                      </div>
                      <div>
                        <strong>{t("duration")}:</strong>{" "}
                        {previousData.summary.duration}
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              </div>
            )}
          </Col>

          <Col lg={6}>
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h5 className="mb-0">{t("extra_services")}</h5>
              <Button
                variant="warning"
                size="sm"
                className="text-white p-2"
                style={{
                  borderRadius: "8px",
                  backgroundColor: "#ff7b00",
                  border: "none",
                }}
                onClick={() => setCurrentStep(4)}
              >
                <MdEditSquare size={18} />
              </Button>
            </div>
            <Card className="mb-4 border-0">
              <Card.Body className="p-4" style={{ borderRadius: "12px" }}>
                <div className="services-list">
                  {extraServices.loading && (
                    <div className="service-item d-flex justify-content-between mb-2 p-2 bg-light rounded">
                      <span>{t("loading_service")}</span>
                      <span className="text-success fw-bold">
                        +{EXTRA_SERVICE_PRICE}€
                      </span>
                    </div>
                  )}
                  {extraServices.unloading && (
                    <div className="service-item d-flex justify-content-between mb-2 p-2 bg-light rounded">
                      <span>{t("unloading_service")}</span>
                      <span className="text-success fw-bold">
                        +{EXTRA_SERVICE_PRICE}€
                      </span>
                    </div>
                  )}
                  {!extraServices.loading && !extraServices.unloading && (
                    <div className="text-muted small">
                      {t("no_extra_services")}
                    </div>
                  )}
                </div>
              </Card.Body>
            </Card>

            {message && (
              <div className="mb-4 mt-4">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h5 className="mb-0">{t("message_to_carrier")}</h5>
                  <Button
                    variant="warning"
                    size="sm"
                    className="text-white p-2"
                    style={{
                      borderRadius: "8px",
                      backgroundColor: "#ff7b00",
                      border: "none",
                    }}
                    onClick={() => setCurrentStep(1)}
                  >
                    <MdEditSquare size={18} />
                  </Button>
                </div>
                <Card className="border-0">
                  <Card.Body className="p-4" style={{ borderRadius: "12px" }}>
                    <div className="message-content text-muted small">
                      {message}
                    </div>
                  </Card.Body>
                </Card>
              </div>
            )}
          </Col>

          <Col lg={6}>
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h5 className="mb-0">{t("shipments")}</h5>
              <Button
                variant="warning"
                size="sm"
                className="text-white p-2"
                style={{
                  borderRadius: "8px",
                  backgroundColor: "#ff7b00",
                  border: "none",
                }}
                onClick={() => setCurrentStep(1)}
              >
                <MdEditSquare size={18} />
              </Button>
            </div>
            <Card className="mb-4 border-0">
              <Card.Body className="p-4" style={{ borderRadius: "12px" }}>
                {allShipmentsFlat.map((shipment, index) => (
                  <div
                    key={index}
                    className={`shipment-item ${
                      index !== allShipmentsFlat.length - 1 ? "mb-3" : "mb-0"
                    }`}
                  >
                    <h6 className="fw-bold mb-1" style={{ fontSize: "1.1rem" }}>
                      {shipment.quantity}x {shipment.type}
                      {shipment.customShipmentText && ` (${shipment.customShipmentText})`}
                    </h6>
                    <div className="text-muted">
                      {shipment.type !== "Dokument" ? (
                        `${formatNumber(shipment.weight)} kg, ` +
                        `${shipment.length}×${shipment.width}×${shipment.height} cm`
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                ))}
                <hr className="my-3" style={{ opacity: "0.1" }} />
                <div className="total-weight">
                  {totalWeight !== 0 ? (
                    <strong style={{ fontSize: "1.1rem" }}>
                      {t("weight_label", "Gewicht")}: {formatNumber(totalWeight)}{" "}
                      kg
                    </strong>
                  ) : (
                    ""
                  )}
                </div>
              </Card.Body>
            </Card>
          </Col>

          <Col lg={12}>
            <Card
              className="mb-4 shadow-sm border-0"
              style={{ backgroundColor: "#ffffff", borderRadius: "16px", border: "1px solid #e2e8f0" }}
            >
              <Card.Body className="p-4 text-center">
                <h3 className="fw-bold mb-3 text-dark">{t("preis")}</h3>

                <div className="overview-price">
                  <div className="price-header mb-2">
                    <div className="price-amount">
                      <h2 className="fw-extrabold text-success" style={{ fontSize: "2.2rem" }}>
                        {subTotal}€{" "}
                        <span className="fs-6 text-muted fw-normal">
                          {t("netto")}
                        </span>
                      </h2>
                    </div>
                  </div>
                  <div className="price-breakdown">
                    <div className="price-row total fs-5">
                      {t("plus_vat", { vatRate: 19 })}{" "}
                      <strong className="text-success">{price}€</strong>
                    </div>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  );
}
